const loaderStyles = {
    container: {
        backgroundColor: '#FFFFFF',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 20000,
        height: '100vh',
        width: '100%',
        position: 'fixed',
        top: 0,
        flexDirection: 'column',
        textAlign: 'center',
        padding: '20px',
    },
    loadingText: {
        marginTop: '16px', 
        fontSize: '16px', 
        color: '#6C6C6C', 
    },
    loadingBar: {
        width: '121px',
          height: '4px',
          background: 'linear-gradient(#273C89) 0/0% no-repeat #F6F6F6',
          backgroundSize: '60% 100%',
          animation: 'progressBar 3s infinite',
          marginTop: '16px',
          '@keyframes progressBar': {
            '0%': {
              backgroundPosition: '-150% 0, -150% 0'
            },
            '66%': {
              backgroundPosition: '250% 0, -150% 0'
            },
            '100%': {
              backgroundPosition: '250% 0, 250% 0'
            },
          }
    },
    footerText: {
        position: 'absolute',
        bottom: '40px',
        zIndex: 2000,
        fontSize: '14px',
        color: '#A1A1A1',
    },
  };
  export default loaderStyles;